export default async (
  userId,
  { userRepository }
) => {
  return await userRepository.isPublisher(userId);
};
